import React, { useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "./ThemeContext";

/**
 * Bridges our Tailwind-driven ThemeContext to Material UI so MUI components
 * (e.g. the form builder) render in dark mode alongside the rest of the app.
 */
const MuiThemeBridge = ({ children }) => {
  const { theme } = useTheme();
  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: theme === "dark" ? "dark" : "light",
          primary: { main: "#4f46e5" }, // indigo-600 to match the brand
        },
      }),
    [theme]
  );

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default MuiThemeBridge;
